export default __webpack_public_path__ + "static/media/flag-réunion.4d56c3a3.svg";